import React from "react";
import styled from "styled-components";
import SectionTitle from "../components/SectionTitle";
// import papers from "../assets/data/papers";
import PhaseBlock from "../components/PhaseBlock";

const papers = [
  {
    phase: 1,
    title: "Phase 1: Foundations",
    papers: [
      {
        title: "Random Forests",
        slidesLink: "",
      },
      {
        title: "XGBoost: A Scalable Tree Boosting System",
        slidesLink: "",
      },
      {
        title:
          "ImageNet Classification with Deep Convolutional Neural Networks (AlexNet)",
        slidesLink: "",
      },
      {
        title: "Deep Residual Learning for Image Recognition (ResNet)",
        slidesLink: "",
      },
      {
        title:
          "Dropout: A Simple Way to Prevent Neural Networks from Overfitting",
        slidesLink: "",
      },
      {
        title: "Batch Normalization: Accelerating Deep Network Training",
        slidesLink: "",
      },
      {
        title: "Adam: A Method for Stochastic Optimization",
        slidesLink: "",
      },
      {
        title: "Word2Vec: Efficient Estimation of Word Representations",
        slidesLink: "",
      },
      {
        title: "GloVe: Global Vectors for Word Representation",
        slidesLink: "",
      },
      {
        title: "LSTM: Long Short-Term Memory",
        slidesLink: "",
      },
      {
        title: "Sequence to Sequence Learning with Neural Networks",
        slidesLink: "",
      },
      {
        title:
          "Neural Machine Translation by Jointly Learning to Align and Translate",
        slidesLink: "",
      },
      {
        title: "Attention Is All You Need",
        slidesLink: "",
      },
      {
        title: "BERT: Pre-training of Deep Bidirectional Transformers",
        slidesLink: "",
      },
      {
        title: "Generative Adversarial Nets",
        slidesLink: "",
      },
      {
        title:
          "U-Net: Convolutional Networks for Biomedical Image Segmentation",
        slidesLink: "",
      },
      {
        title:
          "EfficientNet: Rethinking Model Scaling for Convolutional Neural Networks",
        slidesLink: "",
      },
      {
        title:
          "An Image is Worth 16×16 Words: Transformers for Image Recognition at Scale (ViT)",
        slidesLink: "",
      },
      {
        title: "A Closer Look at Memorization in Deep Networks",
        slidesLink: "",
      },
      {
        title: "Dropout vs. Batch Normalization: An Empirical Study",
        slidesLink: "",
      },
    ],
  },
];

const PaperInsightsStyle = styled.div`
  padding: 10rem 0;
  max-width: 900px;
  margin: 0 auto;

  .hero {
    margin-bottom: 5rem;
  }

  .hero__sub {
    margin-top: 1.5rem;
    color: var(--gray-1);
    line-height: 1.8;
    font-size: 1.8rem;
    text-align: center;
  }

  .tagRow {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
    margin-top: 2rem;
  }

  .tag {
    padding: 0.6rem 1.4rem;
    border: 1px solid var(--gray-2);
    border-radius: 30px;
    font-size: 1.4rem;
  }

  .phases {
    margin-top: 6rem;
    display: flex;
    flex-direction: column;
    gap: 6rem;
  }

  .footer {
    margin-top: 8rem;
    display: flex;
    justify-content: center;
    gap: 2rem;
    flex-wrap: wrap;
  }

  .footer a {
    color: cyan;
    text-decoration: none;
  }

  .footer a:hover {
    text-decoration: underline;
  }

  @media only screen and (max-width: 768px) {
    padding: 6rem 2rem;
  }
`;

export default function PaperInsights() {
  return (
    <PaperInsightsStyle>
      <div className="container">
        <div className="hero">
          <SectionTitle
            heading="*33 Weeks of Paper Reading*"
            subheading="-3 AI/ML papers every week for 33 weeks-"
          />

          <p className="hero__sub">Real breakdowns from an ML Engineer !!!</p>

          <div className="tagRow">
            <span className="tag">Foundations</span>
            <span className="tag">NLP & Transformers</span>
            <span className="tag">Computer Vision</span>
            <span className="tag">GenAI & Agents</span>
            <span className="tag">Trustworthy AI</span>
          </div>
        </div>

        <div className="phases">
          {papers.map((phase) => (
            <PhaseBlock key={phase.id} phase={phase} papers={phase.papers} />
          ))}
        </div>

        <div className="footer">
          <a
            href="https://twitter.com/search?q=%2333WeeksOfPapers"
            target="_blank"
            rel="noreferrer"
          >
            #33WeeksOfPapers
          </a>

          <a href="https://sujansb.medium.com" target="_blank" rel="noreferrer">
            Medium
          </a>
          <a href="https://github.com/sujansb" target="_blank" rel="noreferrer">
            GitHub
          </a>
        </div>
      </div>
    </PaperInsightsStyle>
  );
}
